import Vue from 'vue'
import ViewUI from 'view-design'
import locale from 'view-design/dist/locale/ja-JP'

import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

Vue.use(ViewUI, {
  locale
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
